import { useEffect } from 'react';

/**
 * useBodyScrollLock
 * Locks document.body scroll while the component is mounted (or while `isActive` is true).
 * Automatically restores scroll on unmount / when isActive becomes false.
 *
 * Usage:
 *   useBodyScrollLock();           // always lock while mounted
 *   useBodyScrollLock(isOpen);     // lock only when isOpen === true
 */
export default function useBodyScrollLock(isActive = true) {
    useEffect(() => {
        if (!isActive) return;

        // Save the current scroll position and overflow so we can restore both
        const scrollY = window.scrollY;
        const originalOverflow = document.body.style.overflow;
        const originalPosition = document.body.style.position;
        const originalTop      = document.body.style.top;
        const originalWidth    = document.body.style.width;

        // Lock — fix the body in place so it doesn't jump/shift
        document.body.style.overflow  = 'hidden';
        document.body.style.position  = 'fixed';
        document.body.style.top       = `-${scrollY}px`;
        document.body.style.width     = '100%';

        return () => {
            // Restore
            document.body.style.overflow  = originalOverflow;
            document.body.style.position  = originalPosition;
            document.body.style.top       = originalTop;
            document.body.style.width     = originalWidth;
            // Scroll back to where the user was
            window.scrollTo(0, scrollY);
        };
    }, [isActive]);
}
